import { defineMessages } from "react-intl";
export const messages = defineMessages({
    // Section headings
    objectOnApplication: {
        id: "dploy.core.encumberance-check.object-on-application",
        defaultMessage: "Objekt registrert på saken"
    },
    objectFromSearch: {
        id: "dploy.core.encumberance-check.object-from-search",
        defaultMessage: "Objekt fra søk"
    },
    // Actions
    checkEncumberance: {
        id: "dploy.core.encumberance-check.check-encumberance",
        defaultMessage: "Sjekk heftelser / kjøretøyinfo"
    },
    checkTitle: {
        id: "dploy.core.encumberance-check.check-title",
        defaultMessage: "Sjekk vognkortdata"
    },
    save: {
        id: "dploy.core.encumberance-check.save",
        defaultMessage: "Lagre"
    },
    search: {
        id: "dploy.core.encumberance-check.search",
        defaultMessage: "Søk"
    },
    vegvesenLink: {
        id: "dploy.core.encumberance-check.vegvesen-link",
        defaultMessage: "Sjekk kjøretøyopplysninger hos Statens vegvesen ({regNo})"
    },
    vegvesenLinkEmpty: {
        id: "dploy.core.encumberance-check.vegvesen-link-empty",
        defaultMessage: "Sjekk kjøretøyopplysninger hos Statens vegvesen"
    },
    // Field titles and placeholders
    regNoTitle: {
        id: "dploy.core.encumberance-check.reg-no.title",
        defaultMessage: "Registreringsnummer"
    },
    regNoInvalid: {
        id: "dploy.core.encumberance-check.reg-no.invalid",
        defaultMessage: "Ugyldig registreringsnummer."
    },
    chassisNoTitle: {
        id: "dploy.core.encumberance-check.chassis-no.title",
        defaultMessage: "Serienummer"
    },
    chassisNoPlaceholder: {
        id: "dploy.core.encumberance-check.chassis-no.placeholder",
        defaultMessage: "Serienummer"
    },
    identificationCodeTitle: {
        id: "dploy.core.encumberance-check.identification-code.title",
        defaultMessage: "Kjenningssignal"
    },
    deliveryDateTitle: {
        id: "dploy.core.encumberance-check.delivery-date.title",
        defaultMessage: "Forventet leveringsdato"
    },
    deliveryDatePlaceholder: {
        id: "dploy.core.encumberance-check.delivery-date.placeholder",
        defaultMessage: "DD/MM/YYYY"
    },
    machineRegNoTitle: {
        id: "dploy.core.encumberance-check.machine-reg-no.title",
        defaultMessage: "Maskin registreringsnummer"
    },
    machineRegNoPlaceholder: {
        id: "dploy.core.encumberance-check.machine-reg-no.placeholder",
        defaultMessage: "Maskin registreringsnummer"
    },
    objectNameDescriptionTitle: {
        id: "dploy.core.encumberance-check.object-name-description.title",
        defaultMessage: "Skipets navn"
    },
    portOfRegistryTitle: {
        id: "dploy.core.encumberance-check.port-of-registry.title",
        defaultMessage: "Hjemsted"
    },
    // Object summary rows
    rowRegNo: {
        id: "dploy.core.encumberance-check.row.reg-no",
        defaultMessage: "Registreringsnummer"
    },
    rowChassisNo: {
        id: "dploy.core.encumberance-check.row.chassis-no",
        defaultMessage: "Serienummer"
    },
    rowObjectType: {
        id: "dploy.core.encumberance-check.row.object-type",
        defaultMessage: "Gjenstandsgruppe"
    },
    rowCarType: {
        id: "dploy.core.encumberance-check.row.car-type",
        defaultMessage: "Type"
    },
    rowMake: {
        id: "dploy.core.encumberance-check.row.make",
        defaultMessage: "Merke"
    },
    rowModel: {
        id: "dploy.core.encumberance-check.row.model",
        defaultMessage: "Modell"
    },
    rowEngine: {
        id: "dploy.core.encumberance-check.row.engine",
        defaultMessage: "Beskrivelse"
    },
    rowYear: {
        id: "dploy.core.encumberance-check.row.year",
        defaultMessage: "Årsmodell"
    },
    rowGreenCode: {
        id: "dploy.core.encumberance-check.row.green-code",
        defaultMessage: "Grønn kode"
    },
    yes: {
        id: "dploy.core.encumberance-check.yes",
        defaultMessage: "Ja"
    },
    no: {
        id: "dploy.core.encumberance-check.no",
        defaultMessage: "Nei"
    },
    // Check result accordions
    encumberanceResultTitle: {
        id: "dploy.core.encumberance-check.encumberance-result.title",
        defaultMessage: "Heftelser {regNo}"
    },
    titleCheckResultTitle: {
        id: "dploy.core.encumberance-check.title-check-result.title",
        defaultMessage: "Vognkortdata {regNo}"
    },
    // Check / save failures
    checkFailed: {
        id: "dploy.core.encumberance-check.check-failed",
        defaultMessage: "Sjekk av heftelser / kjøretøyinfo for registreringsnummer {regNo} feilet."
    },
    titleCheckFailed: {
        id: "dploy.core.encumberance-check.title-check-failed",
        defaultMessage: "Sjekk av vognkortdata for registreringsnummer {regNo} feilet."
    },
    saveFailed: {
        id: "dploy.core.encumberance-check.save-failed",
        defaultMessage: "Lagring av endringer feilet."
    },
    // Registration-number search errors
    regNoSearchFailed: {
        id: "dploy.core.encumberance-check.reg-no-search-failed",
        defaultMessage: "Søk etter registreringsnummer {value} feilet."
    },
    regNoSearchGeneralError: {
        id: "dploy.core.encumberance-check.reg-no-search-general-error",
        defaultMessage: "Systemfeil mot Statens Vegvesen under oppslag av registreringsnummer {value}."
    },
    regNoSearchNotFound: {
        id: "dploy.core.encumberance-check.reg-no-search-not-found",
        defaultMessage: "Fant ikke registreringsnummer {value}."
    },
    regNoSearchMultipleResults: {
        id: "dploy.core.encumberance-check.reg-no-search-multiple-results",
        defaultMessage: "Fant flere resultater for registreringsnummer {value}."
    },
    regNoSearchObjectTypeMappingMissing: {
        id: "dploy.core.encumberance-check.reg-no-search-object-type-mapping-missing",
        defaultMessage: "Gjenstand/type kjøretøy for registreringsnummer {value} mangler, må settes etter kontroll mot Statens vegvesen."
    },
    regNoEmpty: {
        id: "dploy.core.encumberance-check.reg-no-empty",
        defaultMessage: "Registreringsnummer kan ikke være tom."
    },
    // Chassis-number search errors
    chassisNoSearchFailed: {
        id: "dploy.core.encumberance-check.chassis-no-search-failed",
        defaultMessage: "Søk etter serienummer {value} feilet."
    },
    chassisNoSearchGeneralError: {
        id: "dploy.core.encumberance-check.chassis-no-search-general-error",
        defaultMessage: "Systemfeil mot Statens Vegvesen under oppslag av serienummer {value}."
    },
    chassisNoSearchNotFound: {
        id: "dploy.core.encumberance-check.chassis-no-search-not-found",
        defaultMessage: "Fant ikke serienummer {value}."
    },
    chassisNoSearchMultipleResults: {
        id: "dploy.core.encumberance-check.chassis-no-search-multiple-results",
        defaultMessage: "Fant flere resultater for serienummer {value}."
    },
    chassisNoSearchObjectTypeMappingMissing: {
        id: "dploy.core.encumberance-check.chassis-no-search-object-type-mapping-missing",
        defaultMessage: "Gjenstand/type kjøretøy for serienummer {value} mangler, må settes etter kontroll mot Statens vegvesen."
    },
    // Replace-application messages
    replaceObject: {
        id: "dploy.core.encumberance-check.replace-object",
        defaultMessage: "Gjenstand for registreringsnummer {regNo} er ulik søknad. Erstatt søknaden og søk opp kjøretøysinformasjon for {regNo} på nytt."
    },
    replaceObjectIfSaved: {
        id: "dploy.core.encumberance-check.replace-object-if-saved",
        defaultMessage: "Gjenstand for registreringsnummer {regNo} er ulik søknad. Søknaden må erstattes og kjøretøysinformasjon søkes opp på nytt for at gjenstand på søknad skal bli riktig."
    },
    replaceObjectCannotReplaceIfSaved: {
        id: "dploy.core.encumberance-check.replace-object-cannot-replace",
        defaultMessage: "Gjenstand for registreringsnummer {regNo} er ulik søknad. Søknaden kan ikke erstattes. Pass på at alle beregninger blir riktig etter at du har lagret."
    },
    replaceObjectCannotReplace: {
        id: "dploy.core.encumberance-check.replace-object-cannot-replace",
        defaultMessage: "Gjenstand for registreringsnummer {regNo} er ulik gjenstand på søknad. Søknaden kan ikke erstattes. Pass på at alle beregninger er riktige."
    },
    objectIsSecurityRegistered: {
        id: "dploy.core.encumberance-check.object-is-security-registered",
        defaultMessage: "{regNo} er tinglyst. Kontakt KS Drift for å få slettet {regNo} fra Brønnøysundregistrene (Brreg)."
    },
    // Registration-number search-state warnings
    warnRegNoNotSearchedInfo: {
        id: "dploy.core.encumberance-check.warn.reg-no-not-searched-info",
        defaultMessage: "Registreringsnummer {regNo} har ikke blitt søkt opp. Informasjon om objektet kan være feil."
    },
    warnSearchValidationDisabled: {
        id: "dploy.core.encumberance-check.warn.search-validation-disabled",
        defaultMessage: "Validering av registreringsnummer er deaktivert. Du kan lagre uten å søke opp registeringsnummeret."
    },
    warnRegNoMustSearch: {
        id: "dploy.core.encumberance-check.warn.reg-no-must-search",
        defaultMessage: "Registreringsnummer {regNo} må søkes opp før du kan lagre."
    },
    warnRegNoNotValidated: {
        id: "dploy.core.encumberance-check.warn.reg-no-not-validated",
        defaultMessage: "Registreringsnummer {regNo} registrert på sak har ikke blitt søkt opp. Informasjon om objektet kan være feil."
    },
    warnDocsWillBeReset: {
        id: "dploy.core.encumberance-check.warn.docs-will-be-reset",
        defaultMessage: "Signerte dokumenter vil resettes ved lagring."
    },
    warnDocsWillBeResetMval96: {
        id: "dploy.core.encumberance-check.warn.docs-will-be-reset-mval96",
        defaultMessage: "Gjenstand for registreringsnummer {regNo} påvirker Mval. §9-6."
    },
    warnLeasingDescription: {
        id: "dploy.core.encumberance-check.warn.leasing-description",
        defaultMessage: "Kontroller at kunde har signert for korrekt kjøretøysbeskrivelse."
    },
    warnLoanEquity: {
        id: "dploy.core.encumberance-check.warn.loan-equity",
        defaultMessage: "Kontroller at korrekt egenkapital er lagt opp."
    },
    errorDocsWillBeReset: {
        id: "dploy.core.encumberance-check.error.docs-will-be-reset",
        defaultMessage: "Registreringsnummer kan ikke endres fordi søknad har signerte dokumenter."
    },
    formLocked: {
        id: "dploy.core.encumberance-check.form-locked",
        defaultMessage: "Søknad er låst."
    }
});
//# sourceMappingURL=messages.js.map